import { render } from "./SocialsLanding.vue?vue&type=template&id=3113f84c&scoped=true"
import script from "./SocialsLanding.vue?vue&type=script&lang=js"
export * from "./SocialsLanding.vue?vue&type=script&lang=js"

import "./SocialsLanding.vue?vue&type=style&index=0&id=3113f84c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3113f84c"

export default script